module.exports = __webpack_public_path__ + "img/categoria.0b12a3a6.svg";